import { useSyncExternalStore } from "react";

/**
 * Routage minimal par hash. Écrans :
 *   #/            → carte pilote (onglet principal, P2-01)
 *   #/carte       → alias de `#/` (liens existants / second moniteur)
 *   #/regulation  → cockpit régulateur (Avance/Retard, espace-temps, synoptique)
 *   #/reseau      → vues réseau : santé, thermomètre, synoptique, carrefours, itinéraires (F3)
 *   #/rejeu       → rejeu de journée (P2-33) — relecture d'une période passée sur la carte
 *   #/admin       → administration de plateforme (CDC §7.1) — régime d'identité à part
 *
 * Pas de routeur externe : le menu noir grandira (Véhicules, Services, Rejeu,
 * Statistiques, Paramètres) mais reste une poignée d'écrans.
 */
export type Screen = "map" | "cockpit" | "network" | "vehicles" | "services" | "stats" | "replay" | "admin" | "settings";

function currentScreen(): Screen {
  const path = window.location.hash.replace(/^#/, "");
  if (path.startsWith("/regulation")) return "cockpit";
  if (path.startsWith("/reseau")) return "network";
  if (path.startsWith("/vehicules")) return "vehicles";
  if (path.startsWith("/services")) return "services";
  if (path.startsWith("/statistiques")) return "stats";
  if (path.startsWith("/rejeu")) return "replay";
  if (path.startsWith("/admin")) return "admin";
  if (path.startsWith("/parametres")) return "settings";
  // `#/` et `#/carte` → carte pilote
  return "map";
}

function subscribe(onChange: () => void): () => void {
  window.addEventListener("hashchange", onChange);
  return () => window.removeEventListener("hashchange", onChange);
}

export function useHashRoute(): Screen {
  return useSyncExternalStore(subscribe, currentScreen, () => "map");
}

export const routes = {
  map: "#/",
  cockpit: "#/regulation",
  network: "#/reseau",
  vehicles: "#/vehicules",
  services: "#/services",
  stats: "#/statistiques",
  replay: "#/rejeu",
  settings: "#/parametres",
  admin: "#/admin",
} as const;
